import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConceptListComponent } from './concept-list.component';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { ConceptService } from './concept.service';

@Component({
    selector: 'convfact-conceptdelete',
    templateUrl: './concept-dialog-delete.component.html',
    styleUrls: ['./concept.component.css'],
    standalone: false
})
export class ConceptDialogDeleteComponent {
  public uid: string = this.data.uid;
  public type: string = this.data.type;
  public error_msg: string;
  public error: boolean = false;
  public message: string = 'Concepto eliminado';

  constructor(
    public dialogRef: MatDialogRef<ConceptListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
    public conceptService: ConceptService
  ) { }

  public delete() {
    this.conceptService.deleteData(this.uid)
      .catch(err => {
        this.message = 'No se puede eliminar un concepto que se está usando'
      });
    this.error = true;
  }

  public closeDialog() {
    this.dialogRef.close();
  }

}
